import { LightObject, LightModel, BookingDB } from "./BookingLightDB"
import { computed, action, observable } from "mobx"
import { uuid } from "../../light/utils"
import { $Session, Session } from "./Session"
import { Member, $Member } from "./Member"

export interface $SessionGroup extends LightObject {
  $session: string
  $booking: string
  $members: { [$id: string]: string }
}

export class SessionGroup implements LightModel {
  constructor(public db: BookingDB, object: $SessionGroup) {
    this.object = object
    if (!object) throw new Error("Missing object in SessionGroup constructor")
  }

  @observable
  object: $SessionGroup

  @computed
  get id() {
    return this.object.$id
  }

  @computed
  get type() {
    return this.object.$type
  }

  @computed
  get children() {
    return null
  }

  isValid = true

  invalidMessage: string

  clean() {}

  @computed
  get session(): Session {
    return new Session(this.db, this.db.file.objects[
      this.object.$session
    ] as $Session)
  }

  static $create($booking: string, $session: string): $SessionGroup {
    return {
      $id: uuid(),
      $type: "sessionGroup",
      $version: uuid(),
      $versionDateString: new Date().toISOString(),
      $parentVersion: null,
      $session: $session,
      $booking: $booking,
      $members: {}
    }
  }

  set session(session: Session) {
    this.object.$session = session.object.$id
  }

  @action.bound
  addMember(member: Member) {
    if (this.members.length < this.session.capacityLeft) {
      if (member.isValid) this.object.$members[member.id] = member.id
      else throw Error("Cannot add invalid member to booking")
    } else
      alert("The number of members in your groups exceeds the session capacity")
  }

  @action.bound
  removeMember(member: Member) {
    delete this.object.$members[member.object.$id]
  }

  @computed
  get members(): Member[] {
    if (this.object.$members) {
      return Object.keys(this.object.$members).map(k => {
        const object = this.db.file.objects[k]
        return new Member(this.db, object as $Member)
      })
    }
    return []
  }
}
